import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import DevTest from '@/components/utils/DevTest.vue'
import { useDoc } from '@/composables/useDoc';
import RezTabFile from '@/store/modules/RezTabFile';
import { ref } from 'vue';
import { useStore } from 'vuex';

export default /*@__PURE__*/_defineComponent({
  __name: 'TestRoute',
  setup(__props) {

const store = useStore();
const doc = useDoc();

async function test() {
    return 
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})